import React, { useEffect, PropsWithChildren, ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EditorPanels } from '../components/editor/EditorPanels.view';

import { EditorActions } from 'Redux/thunks/editor.thunks';

import type { ConfigPanelType, RootState } from 'src/types/state.types';

/*
 * Editor parts with replacements on one side and config on other side.
 */
export const EditorPanelsContainer: React.FC<
  PropsWithChildren<{
    ready?: boolean;
    extraToolbarPanelButtons: ReactNode;
    extraToolbarButtons: ReactNode;
  }>
> = ({ ready, children, extraToolbarPanelButtons, extraToolbarButtons }) => {
  const dispatch = useDispatch();
  const showSchema = useSelector((state: RootState) => state.editor.visiblePanels.schema);
  const showTemplates = useSelector((state: RootState) => state.editor.visiblePanels.templates);

  const onTogglePanel = (panel: ConfigPanelType) =>
    (dispatch as any)(EditorActions.togglePanel(panel));
  const showPanel = (panel: ConfigPanelType) => (dispatch as any)(EditorActions.showPanel(panel));
  const hidePanel = (panel: ConfigPanelType) => (dispatch as any)(EditorActions.hidePanel(panel));

  useEffect(() => {
    ready ? hidePanel('templates') : showPanel('templates');
  }, [ready]);

  return (
    <EditorPanels
      extraToolbarPanelButtons={extraToolbarPanelButtons}
      extraToolbarButtons={extraToolbarButtons}
      showTemplates={showTemplates}
      showSchema={showSchema}
      onTogglePanel={onTogglePanel}
    >
      {children}
    </EditorPanels>
  );
};
